import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Loader from 'react-loader'
import cachios from 'cachios';
import { Link } from 'react-router-dom'
import { BASE } from "../api/api";
import { getName } from 'country-list'
import home from '../assets/Home/home.png'
import crumbarrow from '../assets/Home/right.png'
import pdficon from "../assets/Thesis/pdf.png"
import HeaderNew from '../header/newheader';
import Footer from '../footer/newfooter';

class ThesisOpen extends Component {
    constructor(props) {
        super(props);
        console.log(props, 'props')
        this.state = {
            included: '',
            refer: [],
            journal: [],
            inst: [],
            descr: [],
            authors: [],
            affl: [],
            booktitle: [],
            publisher: [],
            program: [],
            conf: [],
            loader: true,
            articletype: '',
            booktype: '',
            chaptype: '',
            conftype: '',
            thesistype: '',
            nid: props.match.params.nid ? props.match.params.nid : '',
            scroll: props.match ? props.match.params.anchor : ''

        };
    }




    scroll() {
        var scrollingElement = (document.scrollingElement || document.body);
        scrollingElement.scrollTop = scrollingElement.scrollHeight;
    }

    worktypes() {
        cachios.get(BASE + '/jsonapi/taxonomy_term/submit_for_work_types', {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                console.log(data.data.data, 'chk')
                data.data.data.map((value, ind) => {
                    if (value.attributes.name === 'Articles') {
                        this.setState({
                            articletype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Books') {
                        this.setState({
                            booktype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Book Chapters') {
                        this.setState({
                            chaptype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Thesis') {
                        this.setState({
                            thesistype: value.id
                        })
                    }
                    else if (value.attributes.name === 'Conferences') {
                        this.setState({
                            conftype: value.id
                        })
                    }
                })
            })
        console.log(this.state.articletype, this.state.booktype, this.state.chaptype, this.state.thesistype, this.state.conftype, 'chk')
    }

    goto2(id, nid, title) {

        if (id === this.state.thesistype) {
            return '/theses_desc/' + nid
        }
        else if (id === this.state.booktype) {

            return '/book_desc/' + nid
        }
        else if (id === this.state.conftype) {

            return '/conf_desc/' + nid
        }
        else if (id === this.state.chaptype) {

            return '/book_chap_desc/' + nid
        }
        else if (id === this.state.articletype) {

            return '/article_desc/' + nid
        }


    }

    journlink(nid, title, type) {
        return '/content/' + title + '/' + type + '/' + nid
    }

    inst(nid, title) {
        return '/taxonomy/' + title + '/' + nid
    }

    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    apicall(nid) {
        // let nid = this.state.nid
        cachios.get(BASE + 'jsonapi/node/submit_for_work?include=field_cis_program,field_full_text_pdf&filter[drupal_internal__nid]=' + nid, {
            ttl: 500 /* seconds */,
        })
            .then((data) => {
                if (localStorage.getItem('token'))
                    this.checkexpiry()
                this.setState({
                    sub_data: data.data.data[0].attributes,
                    relationships: data.data.data[0].relationships,
                    included: data.data.included,
                    loader: false
                })
                console.log('includex', data)
                {
                    data.data.included ? data.data.included.map((include, index) => {
                        if (include.type === "node--submit_for_work") {
                            let refer = this.state.refer
                            refer.push(include)
                            this.setState({
                                refer: refer
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "node--journals") {
                            let journal = this.state.journal
                            journal.push(include)
                            this.setState({
                                journal: journal
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "node--biographies") {
                            let authors = this.state.authors
                            authors.push(include)
                            this.setState({
                                authors: authors
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "node--conference") {
                            let conf = this.state.conf
                            conf.push(include)
                            this.setState({
                                conf: conf
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--university_college") {
                            let inst = this.state.inst
                            inst.push(include)
                            this.setState({
                                inst: inst
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--descriptors") {
                            let descr = this.state.descr
                            descr.push(include)
                            this.setState({
                                descr: descr
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--affiliations") {
                            let affl = this.state.affl
                            affl.push(include)
                            alert("hi")
                            this.setState({
                                affl: affl
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "taxonomy_term--programs") {
                            let program = this.state.program
                            program.push(include)
                            this.setState({
                                program: program
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }

                        else if (include.type === "taxonomy_term--publisher") {
                            let publisher = this.state.publisher
                            publisher.push(include)
                            this.setState({
                                publisher: publisher
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                        else if (include.type === "file--document") {
                            this.setState({
                                pdf: BASE + include.attributes.uri.url
                            })
                            if (this.state.scroll)
                                this.scroll()
                        }
                    })


                        : this.setState({
                            refer: [],
                            journal: [],
                            inst: [],
                            descr: [],
                            authors: [],
                            affl: []

                        })
                }

            })
            .catch((err) => {
                console.log('include', err)
            })



    }
    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }


    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }


    componentWillMount() {

        this.worktypes()
        this.topFunction()
        this.apicall(this.state.nid)



    }
    render() {
        return (
            <div className='institutions eventpage sub_work' id="innerthesis">
                <HeaderNew />
                <div className="title-banner">
                    <h1 className="heading-one bold white-text">CIS Student Theses</h1>
                </div>
                {this.state.loader ?
                    <Loader loaded={false} color="#165e84" className="spinner" />
                    : ''}
                <div className='container'>
                    <div className='top-contents'>
                        <div className="new-crumbs breadcrumbs gray-text"><Link to='/' className='gray-text'><img className='crumb-home' src={home} /> </Link><img className='rightarrow' src={crumbarrow} /> <Link to='/theses' className='gray-text'>Research</Link> <img className='rightarrow' src={crumbarrow} /><Link to='/theses' className='gray-text'>CIS Student Theses</Link><img className='rightarrow' src={crumbarrow} />{this.state.sub_data ? this.state.sub_data.title : ''}</div>
                        {/* <TopBar data={'data1'} /> */}
                    </div>
                    <div className="" style={{ minHeight: '55.1vh', marginBottom: "140px" }}>
                        <div className='heading-three bold blue-text'>{this.state.sub_data ? this.state.sub_data.title : ''}</div>
                        <div className="field-name-metadata-books">
                            <div className="field-item even">
                                <div className="view-wiki desc-thesis">
                                    {this.state.sub_data ? <div>
                                        {this.state.sub_data.field_student_name ? <p className="thesis-detail gray-text"><span className="bold">Student Name:</span> {this.state.sub_data.field_student_name}</p> : ""}
                                        {this.state.program.length ? <p className="thesis-detail gray-text"><span className="bold">Program Name:</span> {this.state.program.map((program, ind) => {
                                            return (
                                                program.attributes ? program.attributes.field_link ? <a className="body-two" href={program.attributes.field_link.uri}>{program.attributes.name}{ind === this.state.program.length - 1 ? "" : ", "}</a> : `${program.attributes.name}${ind === this.state.program.length - 1 ? "" : ", "}` : ""
                                            )
                                        })} </p> : ""}
                                        {this.state.sub_data.field_year_of_graduation ? <p className="thesis-detail gray-text"><span className="bold">Year of Graduation:</span> {this.state.sub_data.field_year_of_graduation} </p> : ""}
                                    </div> : ""}
                                </div>
                            </div>
                        </div>
                        <div className="field field-type-text-with-summary field-label-hidden">
                            {this.state.sub_data ?
                                <div className="field-items thesis-about">
                                    {this.state.sub_data.field_about ? <p className="heading-three blue-text bold">Abstract</p> : ""}
                                    <div className="field-item text-justify even gray-text" property="content:encoded">
                                        {this.state.sub_data.field_about ? ReactHtmlParser(this.state.sub_data.field_about.value) : ''}

                                    </div>
                                </div>
                                : ''}
                        </div>
                        {this.state.sub_data ? <div className="link-pdf gray-text">
                            {this.state.sub_data.field_proquest_link ? <p className="thesis-detail"><span className="bold">ProQuest Link:</span> <a href={this.state.sub_data.field_proquest_link.uri} target="_blank" >{this.state.sub_data.field_proquest_link.uri}</a></p> : ""}
                            {this.state.relationships ? this.state.relationships.field_full_text_pdf.data.length ? <p className="thesis-detail"><span className="bold">Full Text:</span> {this.state.relationships.field_full_text_pdf.data.map((pdf, ind) => {
                                let file = this.state.included ? this.state.included.filter(x => x.id === pdf.id) : ""
                                console.log("pdf found", file)
                                if (file.length)
                                    return (
                                        <a className="gray-text" href={file[0].attributes.uri ? BASE + file[0].attributes.uri.url : ""} target="_blank" ><img className="pdf-icon" src={pdficon} />{file[0].attributes.filename}</a>
                                    )
                            })}</p> : "" : ""}
                        </div> : ""}
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}

export default ThesisOpen;